module.exports = __webpack_public_path__ + "./favicons/apple-icon-180x180.png";